import { RadioButtonGroup } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { ViewStore } from '../stores/ViewStore';

type Props = {
  viewStore: ViewStore;
  disabled?: boolean;
};

export const AnomaliesModeSelector = observer(function AnomaliesModeSelector({ viewStore, disabled }: Props) {
  const { t } = useTranslation();

  const value = (() => {
    if (viewStore.current.name === 'manualAnomalies') return 'manualAnomalies';
    return 'autoAnomalies';
  })();

  const items = [
    {
      label: t('alertsManagerWidget:viewSelector.autoAnomalies'),
      value: 'autoAnomalies',
      disabled,
    },
    {
      label: t('alertsManagerWidget:viewSelector.manualAnomalies'),
      value: 'manualAnomalies',
      disabled,
    },
  ];

  return (
    <RadioButtonGroup
      items={items}
      value={value}
      onChange={(v) => {
        if (v === 'manualAnomalies') {
          viewStore.select('manualAnomalies');
        } else {
          viewStore.select('autoAnomalies');
        }
      }}
    />
  );
});
